import useBetaVersion from '@hooks/useBetaVersion/useBetaVersion';
import { BetaSurface } from '@hooks/useBetaVersion/betaSurfaces';

export type FilterUiVersion = 'legacy' | 'v2';

// Filter UI version via Beta features (surface DATA_TABLE_FILTERS_V2); 'v2' is the catalog default.
export const useFilterUiVersion = () => {
  const { showLegacy, switchVisible, toggle } = useBetaVersion(BetaSurface.DATA_TABLE_FILTERS_V2);
  const version: FilterUiVersion = showLegacy ? 'legacy' : 'v2';
  return { version, toggle, switchVisible };
};
